export { default, TestRecordBanner } from "./TestRecordBanner";
